import React from 'react';
import {Modal} from 'react-bootstrap';

const DeleteMailModal = (props)=>{
    const {onHide, onConfirm} = props;
    const {id} = props.emailDocument;

    return (
        <Modal show={true}
            onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar correo</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <p>¿Estás seguro que deseas eliminar este correo?</p>
                <p>Esta acción no se puede deshacer.</p>
            </Modal.Body>
            <Modal.Footer>
                <button onClick={ onHide } className='btn btn-primary pull-left'>Cancelar</button>
                <button className='btn btn-danger' onClick={ ()=>onConfirm( id )}>Eliminar</button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteMailModal;


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/MailManager/components/DeleteMailModal/index.jsx